import { render, staticRenderFns } from "./filtre_relevance.vue?vue&type=template&id=7f81d6ad"
import script from "./filtre_relevance.js?vue&type=script&lang=js&external"
export * from "./filtre_relevance.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports